// import '../styles/3d-effects.css'; // Now integrated into Tailwind

const Logo3D = ({ size = 40 }) => {
  return (
    <div
      className="preserve-3d relative animate-rotate3d cursor-pointer hover:[animation-duration:10s]"
      style={{ width: size, height: size }}
    >
      {/* Cube faces */}
      {/* Front face */}
      <div
        className="absolute inset-0 flex items-center justify-center font-[800] text-white rounded-sm border-2 border-[#0f7699] shadow-[0_0_20px_rgba(15,118,153,0.5)] bg-gradient-to-br from-[#0f7699] to-[#2dd4bf]"
        style={{
          fontSize: size * 0.4,
          transform: `translateZ(${size / 2}px)`,
        }}
      >
        3D
      </div>

      {/* Back face */}
      <div
        className="absolute inset-0 flex items-center justify-center font-[800] text-white rounded-sm border-2 border-[#0f7699] shadow-[0_0_20px_rgba(15,118,153,0.5)] bg-gradient-to-br from-[#2dd4bf] to-[#0f7699]"
        style={{
          fontSize: size * 0.4,
          transform: `translateZ(-${size / 2}px) rotateY(180deg)`,
        }}
      >

      </div>

      {/* Right face */}
      <div
        className="absolute inset-0 rounded-sm border-2 border-[#0f7699] shadow-[0_0_15px_rgba(15,118,153,0.4)] bg-gradient-to-br from-[#0f7699] to-[#0a5f7a]"
        style={{
          transform: `rotateY(90deg) translateZ(${size / 2}px)`,
        }}
      />

      {/* Left face */}
      <div
        className="absolute inset-0 rounded-sm border-2 border-[#0f7699] shadow-[0_0_15px_rgba(15,118,153,0.4)] bg-gradient-to-br from-[#0f7699] to-[#0a5f7a]"
        style={{
          transform: `rotateY(-90deg) translateZ(${size / 2}px)`,
        }}
      />

      {/* Top face */}
      <div
        className="absolute inset-0 rounded-sm border-2 border-[#0f7699] shadow-[0_0_15px_rgba(15,118,153,0.4)] bg-gradient-to-br from-[#2dd4bf] to-[#4c9fb9]"
        style={{
          transform: `rotateX(90deg) translateZ(${size / 2}px)`,
        }}
      />
M
      {/* Bottom face */}
      <div
        className="absolute inset-0 rounded-sm border-2 border-[#0f7699] shadow-[0_0_15px_rgba(15,118,153,0.4)] bg-gradient-to-br from-[#0f7699] to-[#0a5f7a]"
        style={{
          transform: `rotateX(-90deg) translateZ(${size / 2}px)`,
        }}
      />
    </div>
  );
};

export default Logo3D;
